module.exports = __webpack_public_path__ + "img/umbrella.b6d68f6f.png";